import React from "react";
import styles from "./pagination.module.css";
import singleLeftSvg from "../../public/images/singleLeft.svg";
import singleRight from "../../public/images/singleRight.png";

function Pagination({ totalPages, currentPage, setCurrentPage }) {
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <div className={styles.paginationButtons}>
      <div>
        <img
          alt="Previous"
          src={singleLeftSvg}
          onClick={handlePrevious}
          className={styles.arrowButton}
        />
        <span className={styles.prevButton} onClick={handlePrevious}>
          Previous
        </span>
      </div>

      <span className={styles.pageNumber}>
        Page {currentPage} / {totalPages}
      </span>

      <div>
        <span className={styles.nextButton} onClick={handleNext}>
          Next
        </span>
        <img
          alt="Next"
          src={singleRight}
          onClick={handleNext}
          className={styles.arrowButton}
        />
      </div>
    </div>
  );
}

export default Pagination;
